<div class="flex flex-col gap-5">
  @for (entry of rows(); track entry.row.key) {
    @let row = entry.row;
    <div class="flex flex-col gap-3.5">
      <section
        class="border border-solid border-neutral-20 rounded px-4 py-3 flex flex-col gap-1"
        data-testid="appointment-request"
      >
        <span class="text-overline text-neutral-60 flex items-center gap-1.5">
          <span
            class="fa-icons icon-regular icon-envelope icon-12"
            aria-hidden="true"
          ></span>
          {{ 'actionsInbox.appointment.requestTitle' | translate }}
        </span>
        <span class="text-body-2 text-neutral-90">
          <strong class="font-bold">{{ row.display.request.from }}</strong>
          <span class="text-neutral-60">
            {{
              'actionsInbox.appointment.receivedAt'
                | translate: { receivedAt: row.display.request.receivedAt }
            }}</span
          >
        </span>
        <span
          class="text-body-2 text-neutral-90"
          data-testid="appointment-request-subject"
          >{{ row.display.request.subject }}</span
        >
        <p
          class="text-body-2 text-neutral-60 italic m-0"
          data-testid="appointment-quote"
        >
          {{
            'actionsInbox.appointment.quote'
              | translate: { quote: row.display.request.quote }
          }}
        </p>
      </section>

      <section class="flex flex-col gap-2">
        <span class="subtitle-2 text-neutral-90">
          {{ 'actionsInbox.appointment.suggested' | translate }}
        </span>

        <dl
          class="m-0 grid grid-cols-[minmax(80px,max-content)_minmax(0,1fr)] gap-x-4 gap-y-1.5"
        >
          <dt class="text-body-2 text-neutral-60">
            {{ 'actionsInbox.appointment.subject' | translate }}
          </dt>
          <dd
            class="m-0 text-body-2 text-neutral-90 font-medium"
            data-testid="appointment-subject"
          >
            {{ row.display.subject }}
          </dd>

          <dt class="text-body-2 text-neutral-60">
            {{ 'actionsInbox.appointment.when' | translate }}
          </dt>
          <dd
            class="m-0 text-body-2 text-neutral-90"
            data-testid="appointment-when"
          >
            @if (entry.when; as range) {
              {{ 'actionsInbox.appointment.whenRange' | translate: range }}
            } @else {
              {{
                'actionsInbox.appointment.whenRaw'
                  | translate
                    : { start: row.display.start, end: row.display.end }
              }}
            }
          </dd>

          <dt class="text-body-2 text-neutral-60">
            {{ 'actionsInbox.appointment.with' | translate }}
          </dt>
          <dd
            class="m-0 text-body-2 text-neutral-90"
            data-testid="appointment-with"
          >
            {{ entry.attendees }}
          </dd>

          @if (row.display.location; as location) {
            <dt class="text-body-2 text-neutral-60">
              {{ 'actionsInbox.appointment.location' | translate }}
            </dt>
            <dd
              class="m-0 text-body-2 text-neutral-90"
              data-testid="appointment-location"
            >
              {{ location }}
            </dd>
          }
        </dl>

        <p
          class="text-caption text-neutral-60 m-0 flex gap-1.5 items-start"
          data-testid="appointment-reason"
        >
          <span
            class="fa-icons icon-regular icon-wand-magic-sparkles icon-12 mt-0.5"
            aria-hidden="true"
          ></span>
          {{ row.display.reason }}
        </p>
      </section>

      <maximizer-action-row-result [item]="row" />
    </div>
  }
</div>
